// récupère les infos utilisateur depuis l'ancienne base IndexedDB
export async function getLegacyUserInfo() {
  try {
    const request = indexedDB.open('1xpay_db_user', 1);

    return new Promise((resolve, reject) => {
      request.onsuccess = async (event) => {
        const db = event.target.result;
        const transaction = db.transaction(['user'], 'readonly');
        const objectStore = transaction.objectStore('user');
        const getAllRequest = objectStore.getAll();

        getAllRequest.onsuccess = () => {
          const users = getAllRequest.result;
          if (users.length === 0) {
            console.log('[Legacy] Aucun utilisateur trouvé dans l\'ancienne DB');
            resolve(null);
            return;
          }

          const user = users[0];
          console.log('[Legacy] Utilisateur trouvé:', user);

          resolve({
            userId: user.userId || null,
            firstName: user.firstName || '',
            lastName: user.lastName || '',
            email: user.email || '',
            reference: user.reference || ''
          });
          db.close();
        };

        getAllRequest.onerror = () => {
          console.error('[Legacy] Erreur lors de la récupération des utilisateurs');
          resolve(null);
          db.close();
        };
      };

      request.onerror = () => {
        console.error('[Legacy] Erreur lors de l\'ouverture de la base de données');
        resolve(null);
      };

      request.onblocked = () => {
        console.error('[Legacy] Ouverture de la base de données bloquée');
        resolve(null);
      };
    });
  } catch (error) {
    console.error('[Legacy] getLegacyUserInfo error:', error);
    return null;
  }
}

// supprime les données utilisateur de l'ancienne base IndexedDB
export async function clearLegacyUserData() {
  try {
    const request = indexedDB.open('1xpay_db_user', 1);

    return new Promise((resolve) => {
      request.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction(['user'], 'readwrite');
        const objectStore = transaction.objectStore('user');
        const clearRequest = objectStore.clear();

        clearRequest.onsuccess = () => {
          console.log('[Legacy] Données utilisateur supprimées de l\'ancienne DB');
          resolve(true);
          db.close();
        };

        clearRequest.onerror = () => {
          console.error('[Legacy] Erreur lors de la suppression des données');
          resolve(false);
          db.close();
        };
      };

      request.onerror = () => {
        console.error('[Legacy] Erreur lors de l\'ouverture de la base pour suppression');
        resolve(false);
      };
    });
  } catch (error) {
    console.error('[Legacy] clearLegacyUserData error:', error);
    return false;
  }
}
